import styled from '@emotion/styled/macro'
import RawLoader from '../Loader'

const Loader = styled(RawLoader)`
  padding-top: 40px;
`
export default Loader
